import { api, imageUrl } from '../services/api';
import {
  getLastSyncMeta,
  getPhotoVaultStats,
  hydrateOfflineImages,
  isNativePhotoVault,
  listKnownImageUrls,
  persistProductImages,
} from './imageCache';

const PAGE = 120;

/**
 * Recorre TODO el catálogo del API y guarda cada foto en el disco de la app.
 * Es lo que hace que sin internet las fotos sí salgan.
 */
export async function collectAllProductImageUrls({ signal } = {}) {
  const urls = [];
  let offset = 0;
  let total = Infinity;

  while (offset < total) {
    if (signal?.aborted) break;
    const res = await api.getProductos({ q: '', categoria: '', subcategoria: '', offset, limit: PAGE });
    const rows = res.data || [];
    total = Number.isFinite(Number(res.total)) ? Number(res.total) : offset + rows.length;
    for (const p of rows) {
      const u = imageUrl(p.imagen);
      if (u) urls.push(u);
    }
    if (!rows.length) break;
    offset += rows.length;
    // Respiro corto para no saturar LVE.
    await new Promise((r) => setTimeout(r, 40));
  }

  return [...new Set(urls)];
}

export async function syncFullPhotoVault({ onProgress, force = false, signal } = {}) {
  if (!isNativePhotoVault()) {
    return { saved: 0, failed: 0, total: 0, skipped: true, reason: 'web' };
  }

  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    const known = listKnownImageUrls();
    await hydrateOfflineImages(known, { limit: 5000 });
    return { saved: getPhotoVaultStats().saved, failed: 0, total: known.length, offline: true };
  }

  const meta = getLastSyncMeta();
  if (
    !force &&
    meta?.at &&
    Date.now() - meta.at < 6 * 60 * 60 * 1000 &&
    meta.saved >= 50
  ) {
    await hydrateOfflineImages(listKnownImageUrls(), { limit: 5000 });
    onProgress?.({
      phase: 'ready',
      done: meta.saved,
      total: meta.total || meta.saved,
      saved: meta.saved,
      failed: meta.failed || 0,
    });
    return { ...meta, skipped: true };
  }

  onProgress?.({ phase: 'listing', done: 0, total: 0, saved: 0, failed: 0 });
  const urls = await collectAllProductImageUrls({ signal });
  onProgress?.({ phase: 'downloading', done: 0, total: urls.length, saved: 0, failed: 0 });

  await hydrateOfflineImages(urls, { limit: 5000 });

  const result = await persistProductImages(urls, {
    limit: 5000,
    onProgress: (p) => onProgress?.({ phase: 'downloading', ...p }),
  });

  onProgress?.({ phase: 'done', ...result });
  return result;
}
